<template>
  <div class="keyword font-34">
    <div class="pull-left">
      <div
        class="left-div"
        :class="computedAddClassActive"
        @click="handlerOperate('add', '+')"
        >加分<div class="left-div--mask"></div
      ></div>
      <div
        class="left-div"
        :class="computedReduceClassActive"
        @click="handlerOperate('remove', '-')"
        >减分<div class="left-div--mask"></div>
      </div>
    </div>
    <ul class="pull-left center">
      <li
        v-for="v in keys"
        :key="v"
        :class="v === 0 ? 'cell-2' : ''"
        class="font-50"
        @click="handlerOperate('number', v)"
        >{{ v }}</li
      >
    </ul>
    <div class="pull-right">
      <div class="right-div font-34 iconfont" @click="handlerOperate('delete')">
        &#xe72b;
      </div>
      <div
        class="right-div"
        :class="{
          disabled: !keywordValue || isDisabled
        }"
        @click="handlerOperate('sure')"
        >确认
        <div class="button-mask"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonKeyword',
  props: {
    keywordStatus: {
      type: String,
      defalut: '+' // 默认限制长度 5 ，不带 + -
    },
    keywordValue: {
      type: String,
      defalut: ''
    },
    isDisabled: {
      type: Boolean,
      defalut: false
    }
  },
  data() {
    return {
      keys: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '.'],
      result: []
    }
  },
  watch: {
    keywordValue() {
      this.result = this.keywordValue.split('')
    }
  },
  computed: {
    computedAddClassActive() {
      if (!this.keywordStatus || this.keywordStatus === '+') {
        return 'active'
      }
      return ''
    },
    computedReduceClassActive() {
      return this.computedAddClassActive ? '' : 'reduce-active'
    }
  },
  methods: {
    handlerOperate(type, key) {
      if (['add', 'remove'].includes(type)) {
        this.$emit('handlerChangeStatus', key)
      } else {
        if (type === 'number') {
          const reg = /^[0-9]+.{0,1}[0-9]{0,4}$/
          const num = this.result.join('') + key
          if (reg.test(num) && num < 10000 && this.result.length < 6) {
            this.result.push(key)
            this.$emit('handlerCallback', this.result)
          }
        } else if (type === 'delete') {
          this.result.pop()
          this.$emit('handlerCallback', this.result)
        } else if (type === 'sure') {
          this.$emit('handlerConfirm', this.result)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.keyword {
  background: #d7d9df;
  width: 100%;
  overflow: hidden;
  padding: 8px 9px;
  .left-div {
    width: 65px;
    height: 100px;
    border-radius: 8px;
    line-height: 100px;
    background: #fff;
    text-align: center;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: rgba(23, 26, 29, 0.6);
    position: relative;
    &:nth-child(1) {
      margin-bottom: 8px;
    }
    &.active {
      color: #006afe;
      .left-div--mask {
        display: block;
        background: rgba(0, 106, 254, 0.12);
      }
    }
    &.reduce-active {
      color: #ff9200;
      .left-div--mask {
        display: block;
        background: rgba(255, 146, 0, 0.12);
      }
    }
  }
  ul {
    width: calc(100% - 130px);
    padding-left: 8px;
    padding-right: 8px;
    overflow: hidden;
    li {
      width: calc((100% - 16px) / 3);
      float: left;
      margin-right: 8px;
      margin-bottom: 8px;
      height: 46px;
      background: #ffffff;
      border-radius: 8px;
      font-weight: 400;
      text-align: center;
      color: #000000;
      line-height: 46px;
      letter-spacing: 1px;
      &:nth-child(3n),
      &:last-child {
        margin-right: 0;
      }
      &:nth-child(10) {
        width: calc((((100% - 16px) / 3) * 2) + 8px);
        margin-right: 8px;
      }
    }
  }
  .right-div {
    width: 65px;
    background: #ffffff;
    border-radius: 4px;
    text-align: center;
    &:nth-child(1) {
      height: 46px;
      margin-bottom: 8px;
      line-height: 46px;
      color: #171a1d;
    }
    &:nth-child(2) {
      height: 154px;
      background: #006afe;
      line-height: 154px;
      color: #ffffff;
      border-radius: 4px;
      position: relative;
    }
    &.disabled .button-mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.7);
    }
  }
  .left-div--mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: none;
    border-radius: 8px;
  }
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
</style>
